import React, { Component } from "react";
import jsonData from "../JasonData/E30TableData.json";
import InquiryPopup from "./InquiryForm";
import PDFJSON from "../JasonData/PDFURL.json";
import { Link } from "react-router-dom";

const proimage = require("../../images/product/E30/Melting Furnace E30.webp");
const proimage1 = require("../../images/product/E30/MeltingFurnaceHotpot.webp");
const proimage2 = require("../../images/product/E5/Referance-Layout.webp");
const imgIcon = require("../../images/product/icon-1.png");

const handleDownload = () => {
  const link = document.createElement("a");
  link.href = process.env.PUBLIC_URL + PDFJSON.E30PDFURL; // Replace with the actual path to your PDF file
  link.download = "E30-Catalogue.pdf"; // Name of the downloaded file
  document.body.appendChild(link);
  link.click();
  document.body.removeChild(link);
};

class E30Details extends Component {
  constructor(props) {
    super(props);
    this.state = {
      isPopupOpen: false,
    };
  }

  openPopup = () => {
    this.setState({ isPopupOpen: true });
  };

  closePopup = () => {
    this.setState({ isPopupOpen: false });
  };

  render() {
    return (
      <>
        <div className="page-content bg-white">
          <div className="content-block">
            <div className="container">
              <div className="row">
                <div className="col-md-4 col-lg-4 col-xl-4">
                  <label className="gradiant-label">
                  MELTING FURNACE E-30
                  </label>
                  <div className="card-body card-body-style">
                    <h4 style={{ textAlign: "center" }}>
                      Standard Power Rating
                    </h4>
                    <hr style={{ border: "2px solid black" }} />
                    <h5 style={{ textAlign: "center" }}>150KW/175KW/250KW/350KW</h5>
                    <h5 style={{ textAlign: "center" }}>250Hz/500Hz/1000Hz</h5>
                  </div>
                  <div className="card-body card-body-style">
                    <h4 style={{ textAlign: "center" }}>
                    HOT POT SIZE
                    </h4>
                    <hr style={{ border: "2px solid black" }} />
                    <h5 style={{ textAlign: "center" }}>200KG/300KG/500KG/750KG</h5>
                  </div>
                  <div className="card-body card-body-style">
                    <h4 style={{ textAlign: "center" }}>
                    MOLTEN METAL
                    </h4>
                    <hr style={{ border: "2px solid black" }} />
                    <h5 className="card-text text-capitalize" style={{ textAlign: "center" }}>Silver/Iron/Copper/Brass/Steel/Aluminum</h5>
                  </div>

                  <label className="gradiant-label">APPLICATION</label>
                  <div
                    className="card-body"
                    style={{
                      background: "#f4f4f4",
                      padding: "15px 10px",
                      marginBottom: "10px",
                      border: "5px solid #fff",
                      boxShadow: "0 0 7px 1px rgba(0,0,0,.26)",
                      borderRadius: "10px",
                    }}
                  >
                    <div>
                      <i className="fa fa-gear mx-2"></i>
                      <span className="card-text">GI/DI Foundry</span>
                    </div>
                    <div>
                      <i className="fa fa-gear mx-2 my-3"></i>
                      <span className="card-text text-capitalize">Non-ferrous Extrusion plant</span>
                    </div>
                    <div>
                      <i className="fa fa-gear mx-2"></i>
                      <span className="card-text text-capitalize">Lost wax casting</span>
                    </div>
                    <div>
                      <i className="fa fa-gear mx-2 my-3"></i>
                      <span className="card-text text-capitalize">Steel Foundry</span>
                    </div>
                  </div>
                </div>

                <div className="col-md-8" style={{ textAlign: "center" }}>
                  <div className="blog-post blog-lg blog-rounded ">
                    <div className="">
                      <img className="img-fluid" src={proimage} alt="image" />
                    </div>
                    <button
                      className="site-button black m-r5 my-2"
                      type="button"
                      onClick={this.openPopup}
                    >
                      <span className="site-button-inr">
                        Inquiry <i className="ti-email"></i>
                      </span>
                    </button>
                    <InquiryPopup
                      className="inq-pop"
                      show={this.state.isPopupOpen}
                      onClose={this.closePopup}
                    />

                    <button
                      className="site-button black m-r5"
                      type="button"
                      onClick={handleDownload}
                    >
                      <span className="site-button-inr">
                        Catalogue <i className="ti-download"></i>
                      </span>
                    </button>
                  </div>
                  <div></div>
                </div>
              </div>
            </div>
          </div>

          {/* start */}
          <div className="page-content " style={{ background: "#f4f4f4" }}>
                    <div className="content-block">                        
                    <div className="section-full content-inner video-section">
                            <div className="container">
                                <div className="section-content">
                                    <div className="row d-flex">
                                        <div className="col-lg-6 col-md-12 m-b30">
                                            <div className="video-bx">
                                                <img src={proimage1} alt="Signature" />
                                            </div>
                                        </div>
                                        <div className="col-lg-6 col-md-12 m-b30 align-self-center video-infobx">
                                          <h3>Melt Rate Kg/Hour</h3>
                                          <table>
                                            <thead>
                                              <tr>
                                                <th>Size</th>
                                                <th>Brass @950°C (Kg/Hr)</th>
                                                <th>Copper @1100°C (Kg/Hr)</th>
                                                <th>Steel @1650°C (Kg/Hr)</th>
                                                <th>Iron @1485°C (Kg/Hr)</th>
                                              </tr>
                                            </thead>
                                            <tbody>
                                              {jsonData.map((data) => (
                                                <tr key={data.id}>
                                                  <td>{data.size}</td>
                                                  <td>{data.brass}</td>
                                                  <td>{data.copper}</td>
                                                  <td>{data.steel}</td>
                                                  <td>{data.iron}</td>
                                                </tr>
                                              ))}
                                            </tbody>
                                          </table>                                            
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>  

          {/* end */}

          <div
            className="content-block"
            style={{
              paddingBottom: "30px",
              paddingTop: "30px",
            }}
          >
            <div
              id="masonry"
              className="dlab-blog-grid-2"
              style={{
                width: "100%",
                paddingLeft: "10px",
                paddingRight: "10px",
              }}
            >
              <div className="row">
                <div className="post card-container col-lg-6 col-md-6 col-sm-12">
                  <img src={imgIcon} alt="icon-1" />
                  <span className="card-text mx-3" style={{ fontSize: "24px" }}>
                  3D Proposed Layout
                  </span>
                  <div className="dlab-divider divider-2px bg-red" />
                  <img className="img-fluid" src={proimage2} />
                </div>

                <div className="post card-container col-lg-6 col-md-6 col-sm-12">
                  <img src={imgIcon} alt="icon-1" />
                  <span className="card-text mx-3" style={{ fontSize: "24px" }}>
                    Related Products
                  </span>
                  <div className="dlab-divider divider-2px bg-red" />
                  <div className="row">
                    <div className="post card-container col-lg-6 col-md-6 col-sm-12">
                      <Link to="/e50" class="site-button outline outline-2 black m-r15 " type="button" style={{ width: "200px" }}
                      >E-50</Link>
                      <Link to="/e30" class="site-button outline outline-2 black m-r15  my-4" type="button" style={{ width: "200px" }}
                      >E-30</Link>
                      <Link to="/hotpot" class="site-button outline outline-2 black m-r15" type="button" style={{ width: "200px" }}
                      >Hot Pot</Link>
                    </div>
                    <div className="post card-container col-lg-6 col-md-6 col-sm-12">
                      <Link to="/e70" class="site-button outline outline-2 black m-r15  " type="button" style={{ width: "200px" }}
                      >E-70</Link>
                      <Link to="/e10" class="site-button outline outline-2 black m-r15  my-4" type="button" style={{ width: "200px" }}
                      >E-10</Link>
                      <Link to="/spares" class="site-button outline outline-2 black m-r15" type="button" style={{ width: "200px" }}
                      >Spares</Link>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </>
    );
  }
}
export default E30Details;
